import {
  Box,
  Button,
  Collapse,
  Container,
  Divider,
  Flex,
  Grid,
  GridItem,
  Heading,
  Link,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useState } from "react";
import ButtonTheme from "./ButtonTheme";
import ContactFormButton from "./old-site/ContactForm2";

import { formatNumberWithCommas } from "../utils";
import { PdfIcon, PhoneIcon, PlayIcon, PlusIcon } from "./Icons";
import { spaceSqFt } from "./Utils";
import {API_BASE_IMAGES} from "../OldApp";

const PropertyTable = ({ propertyDetail }) => {
  const [isOpenArray, setIsOpenArray] = useState(Array(6).fill(false));
  const spaceCond = {
    turnkey: "Immediately",
    "2nd generation": "Within 30 days",
    "pre-existing": "3 months",
    challenged: "6 months",
    "core and shell": "9 months",
  };
  // Function to toggle the state of a specific row
  const toggleRow = (index) => {
    const updatedArray = [...isOpenArray];
    updatedArray[index] = !updatedArray[index];
    setIsOpenArray(updatedArray);
  };

  const convertDate = (inputString) => {
    const [year, month, day] = inputString.split("-");
    return `${month}/${day}/${year}`;
  };

  return (
    <Box my={20}>
      <Container maxW={{ lg: "70%", sm: "90%", base: "100%" }}>
        <Heading color={"DarkBlue"} fontSize={"5xl"} mb={8}>
          {propertyDetail.externalName || propertyDetail.name}
        </Heading>
        {propertyDetail && !propertyDetail.available ? "" :
          <Text color={"DarkTeal"} fontSize={"2xl"}>

          </Text>}
        <Text color={"DarkTeal"} mt={3}>
          {propertyDetail.street_address}, {propertyDetail?.city?.name},{" "}
          {propertyDetail.state}
        </Text>
        {propertyDetail && !propertyDetail.available ? "" :
          <Text color={"DarkTeal"} mt={3}>
            Available square footage:{" "}
            {formatNumberWithCommas(propertyDetail.space_available)} SQ FT
          </Text>}

        {propertyDetail && !propertyDetail.available && (
          <>
            <Text color={"DarkTeal"} fontSize={"2xl"} mt={"5 !important"}>
              Fully leased
            </Text>
            <Text color={"DarkTeal"} mt={3}>
              This property is fully leased.&nbsp;
              <ContactFormButton property={propertyDetail} ml={"5px"}>
                {({ showModal }) => (
                  <Link role={"link"} className=" " onClick={showModal} textDecoration={"underline"}>
                    Click here
                  </Link>
                )}
              </ContactFormButton>{" "}
              to be added to the waitlist and notified about upcoming
              availabilities.
            </Text>
          </>
        )}

        {propertyDetail && propertyDetail.available && (
          <>




            <Text color={"DarkTeal"} fontSize={"2xl"} mt={12} mb={6}>
              Space Details
            </Text>
            <TableContainer display={{ md: "block", base: "none" }}>
              <Table
                sx={{
                  td: {
                    borderBottom: 0,
                  },
                  "thead tr th": {
                    color: "DarkBlue",
                    fontSize: "md",
                    textTransform: "capitalize",
                    fontFamily: "Gotham A",
                    fontWeight: "500",
                    borderBottom: "1px solid #ccc",
                    pb: 6
                  },
                  "tbody tr": {
                    borderBottom: "10px solid white",
                    background: "#70d0ec33",
                    // boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.10)",
                    my: 2,
                    color: "DarkBlue",
                  },
                  "tr td": {
                    p: 4,
                    _first: {
                      borderRadius: "100px 0 0 100px",
                    },
                    _last: {
                      borderRadius: "0 100px 100px 0",
                    },
                  },
                }}
              >
                <Thead>
                  <Tr>
                    <Th>Suite</Th>
                    <Th>Size (SQ FT)</Th>
                    <Th>Timing/Availability</Th>
                    <Th>Details, Floor Plans, & Tours</Th>
                    <Th></Th>
                  </Tr>
                </Thead>
                <Divider borderColor={"transparent"} mt={6} />
                <Tbody>
                  {propertyDetail && propertyDetail.availableSpaces && (
                    <>
                      {propertyDetail?.availableSpaces.map((space, index) => (
                        <React.Fragment key={index}>
                          <Tr onClick={() => toggleRow(index)}>
                            <Td>{space.suite}</Td>
                            <Td>
                              {formatNumberWithCommas(spaceSqFt(space))}
                            </Td>
                            <Td>
                              {space.availability_date ||
                                space.space_condition === "2nd generation" ||
                                space.space_condition === "turnkey" ? '' : '±'}

                              {space.availability_date
                                ? convertDate(space.availability_date)
                                : spaceCond[space.space_condition] ||
                                space.space_condition}
                            </Td>
                            <Td textDecor={"underline"} cursor={"pointer"}>
                              Expand to View
                            </Td>
                            <Td>
                              <PlusIcon
                                cursor={"pointer"}
                                transition={"all ease .3s"}
                                transform={
                                  isOpenArray[index] ? "rotate(45deg)" : ""
                                }
                              />
                            </Td>
                          </Tr>
                          <Tr display={isOpenArray[index] ? "" : "none"}>
                            <Td colSpan={5} bgColor={"white"} p={0}>
                              <Collapse in={isOpenArray[index]} animateOpacity>
                                <Box
                                  px={12}
                                  py={4}
                                  borderRadius={"20px"}
                                  border={"1px solid #E8E8E8"}
                                  background={"#FFF"}
                                >
                                  <Flex mb={10} gap={10}>
                                    <Box >
                                      <Text
                                        color={"BrightTurquoise"}
                                        fontWeight={"600"}
                                      >
                                        SUITE
                                      </Text>
                                      <Text
                                        color={"DarkBlue"}
                                        fontWeight={"400"}
                                        fontSize={"sm"}
                                      >
                                        {space.suite}
                                      </Text>
                                    </Box>
                                    <Box>
                                      <Text
                                        color={"BrightTurquoise"}
                                        fontWeight={"600"}
                                      >
                                        SIZE SQ FT
                                      </Text>
                                      <Text
                                        color={"DarkBlue"}
                                        fontWeight={"400"}
                                        fontSize={"sm"}
                                      >
                                        {formatNumberWithCommas(
                                          spaceSqFt(space)
                                        )}
                                      </Text>
                                    </Box>
                                    <Box>
                                      <Text
                                        color={"BrightTurquoise"}
                                        fontWeight={"600"}
                                      >
                                        TIMING/AVAILABILITY
                                      </Text>
                                      <Text
                                        color={"DarkBlue"}
                                        fontWeight={"400"}
                                        fontSize={"sm"}
                                      >

                                        {space.availability_date ||
                                          space.space_condition === "2nd generation" ||
                                          space.space_condition === "turnkey" ? '' : '±'}
                                        {space.availability_date
                                          ? convertDate(space.availability_date)
                                          : spaceCond[space.space_condition] ||
                                          space.space_condition}
                                      </Text>
                                    </Box>
                                  </Flex>
                                  <Text noOfLines={3} whiteSpace={"pre-line"}>
                                    {space.description}
                                  </Text>
                                  <Flex
                                    mt={10}
                                    justifyContent={"space-between"}
                                    alignItems={"center"}
                                  >
                                    <Box>
                                      {space &&
                                        space.contact_users &&
                                        space.contact_users[0] &&
                                        space.contact_users[0].phone && (
                                          <Box
                                            textAlign={"center"}
                                            border={"2px solid"}
                                            borderColor={"DarkBlue"}
                                            w={"33px"}
                                            h={"33px"}
                                            lineHeight={"33px"}
                                            borderRadius={"full"}
                                          >
                                            <PhoneIcon
                                              sx={{
                                                path: {
                                                  fill: "DarkBlue",
                                                },
                                              }}
                                              w={4}
                                              h={4}
                                            />
                                          </Box>
                                        )}
                                    </Box>
                                    <Flex gap={10} textAlign={"right"}>
                                      {space.matterport_tours &&
                                        space.matterport_tours[0] &&
                                        space.matterport_tours[0].url && (
                                          <Flex
                                            gap={6}
                                            alignItems={"center"}
                                            textAlign={"center"}
                                          >
                                            <a
                                              href={
                                                space.matterport_tours[0].url
                                              }
                                              target="_blank"
                                              rel="noreferrer"
                                              className="btn-virtual-tour"
                                            >
                                              <Grid
                                                gridTemplateColumns={{
                                                  md: "repeat(2,1fr)",
                                                  base: "repeat(1,1fr)",
                                                }}
                                              >
                                                <GridItem>
                                                  <Text
                                                    color={"DarkBlue"}
                                                    gap={6}
                                                  >
                                                    Virtual Tour
                                                  </Text>
                                                </GridItem>{" "}
                                                <GridItem>
                                                  <PlayIcon w={6} h={6} />
                                                </GridItem>
                                              </Grid>
                                            </a>
                                          </Flex>
                                        )}
                                      {space.matterport_tours &&
                                        1 == 2 &&
                                        space.matterport_tours[0] &&
                                        space.matterport_tours[0].url && (
                                          <Flex
                                            gap={6}
                                            alignItems={"center"}
                                            textAlign={"right"}
                                          >
                                            <a
                                              href={
                                                space.matterport_tours[0].url
                                              }
                                              target="_blank"
                                              rel="noreferrer"
                                              className="btn-360-tour"
                                            >
                                              <Text color={"DarkBlue"}>
                                                360º Tour
                                              </Text>
                                              <Box
                                                fontSize={"3xs"}
                                                w={6}
                                                h={6}
                                                border={"2px solid"}
                                                borderColor={"DarkBlue"}
                                                borderRadius={"full"}
                                              >
                                                360º
                                              </Box>
                                            </a>
                                          </Flex>
                                        )}
                                      {space.floor_plan_photos &&
                                        space.floor_plan_photos[0] &&
                                        space.floor_plan_photos[0].path && (
                                          <Flex
                                            gap={6}
                                            alignItems={"center"}
                                            textAlign={"center"}
                                          >
                                            <a
                                              href={
                                                  API_BASE_IMAGES +
                                                space.floor_plan_photos[0].path
                                              }
                                              target="_blank"
                                              rel="noreferrer"
                                              className="btn-floor-plans"
                                            >
                                              <Grid
                                                gridTemplateColumns={{
                                                  md: "repeat(2,1fr)",
                                                  base: "repeat(1,1fr)",
                                                }}
                                              >
                                                <GridItem>
                                                  <Text color={"DarkBlue"}>
                                                    Floor Plans
                                                  </Text>
                                                </GridItem>
                                                <GridItem>
                                                  <PdfIcon w={6} h={6} />
                                                </GridItem>
                                              </Grid>
                                            </a>
                                          </Flex>
                                        )}

                                      {space.other_videos &&
                                        space.other_videos[0] &&
                                        space.other_videos[0].url &&
                                        space.other_videos[0].title && (
                                          <Flex
                                            gap={6}
                                            alignItems={"center"}
                                            textAlign={"center"}
                                          >
                                            <a
                                              href={space.other_videos[0].url}
                                              target="_blank"
                                              rel="noreferrer"
                                              className="btn-other-videos"
                                            >
                                              {/* <Grid
                                                gridTemplateColumns={{
                                                  md: "repeat(2,1fr)",
                                                  base: "repeat(1,1fr)",
                                                }}
                                              > */}
                                              <Flex gap={6} flexDir={{md:"row",base:"column"}}>
                                                <Text color={"DarkBlue"}>
                                                  {
                                                    space.other_videos[0]
                                                      .title
                                                  }
                                                </Text>
                                                {/* </GridItem>
                                                <GridItem> */}
                                                <PlayIcon w={6} h={6} />
                                              </Flex>
                                              {/* </Grid> */}
                                            </a>
                                          </Flex>
                                        )}
                                    </Flex>
                                  </Flex>
                                </Box>
                              </Collapse>
                            </Td>
                          </Tr>
                        </React.Fragment>
                      ))}
                    </>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          </>
        )}
        <Box display={{ md: "none", base: "block" }} mt={5}>
          {propertyDetail && propertyDetail.availableSpaces && (
            <>
              {propertyDetail?.availableSpaces.map((space, index) => (
                <React.Fragment key={index}>
                  <Box
                    mt={5}
                    p={{ sm: 5, base: 2 }}
                    borderRadius={"20px"}
                    overflow={"hidden"}
                    border={"1px solid #E8E8E8"}
                    background={"rgb(112 208 236 / 20%)"}
                    boxShadow={"0px 0px 20px 0px rgba(0, 0, 0, 0.10)"}
                    fontSize={"xs"}
                  >
                    <Grid
                      gridTemplateColumns={"repeat(3, 1fr)"}
                      gap={{ sm: 6, base: 4 }}
                    >
                      <Box>
                        <Text color={"BrightTurquoise"} fontWeight={"600"}>
                          SUITE
                        </Text>
                        <Text
                          color={"DarkBlue"}
                          fontWeight={"400"}
                          fontSize={"sm"}
                        >
                          {space.suite}
                        </Text>
                      </Box>
                      <Box>
                        <Text color={"BrightTurquoise"} fontWeight={"600"}>
                          SIZE SQ FT
                        </Text>
                        <Text
                          color={"DarkBlue"}
                          fontWeight={"400"}
                          fontSize={"sm"}
                        >
                          {formatNumberWithCommas(
                            spaceSqFt(space)
                          )}
                        </Text>
                      </Box>
                      <Box >
                        <Text color={"BrightTurquoise"} fontWeight={"600"}>
                          TIMING/AVAILABILITY
                        </Text>
                        <Text
                          color={"DarkBlue"}
                          fontWeight={"400"}
                          fontSize={"sm"}
                        >
                          {space.availability_date ||
                            space.space_condition === "2nd generation" ||
                            space.space_condition === "turnkey" ? '' : '±'}
                          {space.availability_date
                            ? convertDate(space.availability_date)
                            : spaceCond[space.space_condition] ||
                            space.space_condition}
                        </Text>
                      </Box>
                    </Grid>
                    <ButtonTheme
                      btnText={"Expand to view"}
                      chakraProps={{
                        w: "100%",
                        mt: 6,
                        onClick: () => toggleRow(index),
                      }}
                    />
                  </Box>
                  <Collapse in={isOpenArray[index]} animateOpacity>
                    <Box
                      px={{ md: 12, sm: 6, base: 4 }}
                      py={4}
                      borderRadius={"20px"}
                      border={"1px solid #E8E8E8"}
                      background={"#FFF"}
                      fontSize={"xs"}
                      mt={4}
                    >
                      <Flex mb={10} gap={{ md: 10, sm: 6, base: 4 }}>
                        <Box>
                          <Text color={"BrightTurquoise"} fontWeight={"600"}>
                            SUITE
                          </Text>
                          <Text
                            color={"DarkBlue"}
                            fontWeight={"400"}
                            fontSize={"sm"}
                          >
                            {space.suite}
                          </Text>
                        </Box>
                        <Box>
                          <Text color={"BrightTurquoise"} fontWeight={"600"}>
                            SIZE SQ FT
                          </Text>
                          <Text
                            color={"DarkBlue"}
                            fontWeight={"400"}
                            fontSize={"sm"}
                          >
                            {formatNumberWithCommas(
                              spaceSqFt(space)
                            )}
                          </Text>
                        </Box>
                        <Box>
                          <Text color={"BrightTurquoise"} fontWeight={"600"}>
                            TIMING/AVAILABILITY
                          </Text>
                          <Text
                            color={"DarkBlue"}
                            fontWeight={"400"}
                            fontSize={"sm"}
                          >
                            {space.availability_date ||
                              space.space_condition === "2nd generation" ||
                              space.space_condition === "turnkey" ? '' : '±'}
                            {space.availability_date
                              ? convertDate(space.availability_date)
                              : spaceCond[space.space_condition] ||
                              space.space_condition}
                          </Text>
                        </Box>
                      </Flex>
                      <Text noOfLines={3} whiteSpace={"pre-line"}>
                        {space.description}
                      </Text>
                      <Flex
                        mt={10}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        {space &&
                          space.contact_users &&
                          space.contact_users[0] &&
                          space.contact_users[0].phone && (
                            <Box
                              textAlign={"center"}
                              border={"2px solid"}
                              borderColor={"DarkBlue"}
                              w={"33px"}
                              h={"33px"}
                              lineHeight={"33px"}
                              borderRadius={"full"}
                            >
                              <PhoneIcon
                                sx={{
                                  path: {
                                    fill: "DarkBlue",
                                  },
                                }}
                                w={4}
                                h={4}
                              />
                            </Box>
                          )}
                        {space.matterport_tours &&
                          space.matterport_tours[0] &&
                          space.matterport_tours[0].url && (
                            <a href={space.matterport_tours[0].url}>
                              <PlayIcon w={6} h={6} />
                            </a>
                          )}

                        {space.floor_plan_photos &&
                          space.floor_plan_photos[0] &&
                          space.floor_plan_photos[0].path && (
                            <a
                              href={API_BASE_IMAGES + space.floor_plan_photos[0].path}
                            >
                              <PdfIcon w={6} h={6} />
                            </a>
                          )}
                      </Flex>
                    </Box>
                  </Collapse>
                </React.Fragment>
              ))}
            </>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default PropertyTable;
